import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../context/AuthContext';
import { getUserTemplates, deleteTemplate } from '../../../firebase/services';

const MyTemplatesScreen = () => {
  const { t } = useTranslation();
  const { currentUser } = useContext(AuthContext);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const result = await getUserTemplates(currentUser.uid);
        setTemplates(result);
      } catch (error) {
        console.error('Failed to fetch templates:', error);
      }
    };
    fetchTemplates();
  }, [currentUser.uid]);

  const handleDelete = async (template) => {
    if (!window.confirm(t('templates.deleteConfirm'))) return;
    try {
      await deleteTemplate(template.id);
      setTemplates(prev => prev.filter(t => t.id !== template.id));
    } catch (error) {
      console.error('Failed to delete template:', error);
    }
  };

  const formatDate = (createdAt) => {
    if (!createdAt || typeof createdAt.toDate !== 'function') return '';
    return createdAt.toDate().toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const groupedTemplates = {};
  templates.forEach(template => {
    const cause = template.causeTitle || 'Other';
    if (!groupedTemplates[cause]) {
      groupedTemplates[cause] = [];
    }
    groupedTemplates[cause].push(template);
  });
  const sortedCauseKeys = Object.keys(groupedTemplates).sort();

  return (
    <div style={{ backgroundColor: '#F8F8F8', minHeight: '100vh', padding: '16px', maxWidth: '400px', margin: '0 auto', fontFamily: 'Inter, sans-serif' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <span
          style={{ fontSize: '24px', cursor: 'pointer', marginRight: '12px' }}
          onClick={() => window.history.back()}
        >
          ←
        </span>
        <h1 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '18px', fontWeight: 'bold', color: '#1a2b4a', margin: 0 }}>
          {t('templates.title')}
        </h1>
      </div>

      {templates.length > 0 ? (
        sortedCauseKeys.map((cause, groupIndex) => (
          <div key={cause}>
            <div style={{
              fontSize: '12px',
              textTransform: 'uppercase',
              color: '#808080',
              letterSpacing: '0.5px',
              fontWeight: 600,
              margin: groupIndex === 0 ? '0 0 8px 0' : '20px 0 8px 0',
            }}>
              {cause}
            </div>
            {groupedTemplates[cause].map(template => (
              <div
                key={template.id}
                style={{ backgroundColor: 'white', borderRadius: '8px', padding: '16px', marginBottom: '12px', border: '1px solid #eee', position: 'relative' }}
              >
                <div style={{ fontFamily: 'Poppins, sans-serif', fontSize: '14px', fontWeight: 600, color: '#1a2b4a' }}>
                  {template.title}
                </div>
                {formatDate(template.createdAt) && (
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '10px', color: '#6b7280', marginTop: '6px' }}>
                    {t('templates.saved', { date: formatDate(template.createdAt) })}
                  </div>
                )}
                <span
                  style={{ position: 'absolute', top: '12px', right: '12px', fontSize: '18px', color: '#6b7280', cursor: 'pointer', padding: '4px' }}
                  onClick={() => handleDelete(template)}
                >
                  ✕
                </span>
              </div>
            ))}
          </div>
        ))
      ) : (
        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#6b7280', textAlign: 'center', marginTop: '40px', padding: '0 20px' }}>
          {t('templates.noTemplates')}
        </p>
      )}
    </div>
  );
};

export default MyTemplatesScreen;
